import { withRouter } from 'react-router';
import Body from './Body.component';

export default withRouter(Body);
